import React from "react";
import ScrollspyNav from "react-scrollspy-nav";
import { ReactComponent as FilterIcon } from "assets/svgs/filters.svg";
import { useDispatch, useSelector } from "react-redux";
import { getNumberOfSettledFilters } from "utils/filters";
import Image from "components/image";
import clsx from "clsx/lite";
import { cartMeals } from "utils/constants";
import { toggleFilterPanel } from "slices/filters";

const CollectionNav = ({ collections, hideCollections = false, hideFilter }) => {
	const dispatch = useDispatch();
	const { tags, isSearchOpen } = useSelector((state) => state.filters);
	const totalSettledFilters = getNumberOfSettledFilters(tags);
	const { view } = useSelector(state => state.global);

	const filteredCollections = collections.filter((c) => c.show);
	const disabled = view === cartMeals;

	return (
		<div className={clsx(
			"w-full flex items-center lg:block h-fit lg:top-36 z-30 bg-white lg:pb-0 sticky top-0 md:top-[70px]",
			isSearchOpen ? "hidden lg:flex" : "lg:w-full lg:pb-1")}>
			<div className={clsx(isSearchOpen ? "w-0 md:w-auto" : hideFilter ? "w-full" : "w-11/12 md:w-auto", "flex")}>
				<div className={clsx("lg:hidden flex", !hideCollections && !hideFilter && "pr-5", hideFilter && "pr-5")}>
					{!hideFilter &&
						<button disabled={disabled}
							className={clsx(
								"relative bg-white-smoke p-1 rounded-full",
								disabled && "opacity-30 pointer-events-none")}
							onClick={() => dispatch(toggleFilterPanel())}
						>
							{totalSettledFilters > 0 && <span className="badge -right-2 top-1">{totalSettledFilters}</span>}
							<FilterIcon />
						</button>}
				</div>
				{!hideCollections && !disabled && <div className="overflow-x-auto md:overflow-x-auto">
					<ScrollspyNav
						offset={-200}
						scrollDuration={100}
						scrollTargetIds={[...filteredCollections.map((c) => c.collection.handle)]}
						activeNavClass="collection-is-active"
					>
						<div className="flex lg:flex-col gap-4 justify-between whitespace-nowrap lg:whitespace-normal flex-nowrap py-3">
							{filteredCollections.length > 0 &&
								filteredCollections
									.map((c, index) => (
										<span className="text-[#414141] text-base last:pr-4" key={`${c.collection.handle}-${index}`}>
											<a href={`#${c.collection.handle}`}>
												{c.image &&
													<Image
														className="size-4 lg:size-5 mr-2 mt-0.5 inline-block "
														image={c.image} />
												}
												{c.collection.title}
											</a>
										</span>
									))}
						</div>
					</ScrollspyNav>
				</div>}
			</div>
		</div>
	);
};
export default CollectionNav;
